import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
// import 'bootstrap/dist/css/bootstrap.min.css';
import './welcome.css'



const WelcomePage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [gifSrc, setGifSrc] = useState("/assets/video/beforecutting.png"); 

  useEffect(() => {
    const hasSeen = localStorage.getItem("welcomeSeen");

    if(hasSeen === "true") {
      navigate("/login")
    }
  }, [navigate]);

  const handleRibonCutting = () => {
    //  console.log("vikas")
    setLoading(true);

    localStorage.setItem("welcomeSeen", "true");
    // Reset gif by changing src with a timestamp
    // setGifSrc(`http://localhost:3000/assets/video/cutting.gif?${new Date().getTime()}`);
    // setGifSrc(`https://weconnect1.com:8080/assets/video/cutting.gif`);
    setGifSrc(`https://weconnect1.com:8080/assets/video/cutting.gif?${new Date().getTime()}`);
    setTimeout(() => {
      setLoading(false);
      navigate("/login");
    }, 5000);
  };

  return (
    <div className="position-relative vh-100 vw-100 overflow-hidden">

        <img
          src="assets/video/bgImage.jpg"
          alt="Navratri Celebration"
          className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
        />


      {/* <video
        autoPlay
        loop
        muted
        playsInline
        className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
      >
        <source src="assets/video/navratri.mp4" type="video/mp4" />
        your Browser does not support the video tag.
      </video> */}


      {/* Start Content */}
<div className="position-relative d-flex flex-column justify-content-between align-items-center h-100 text-white p-4">

{/* Navratri image top-center */}
<div className="navratriImg2 ">
  <img src="/assets/img/logo/team1-consultancy1.png" alt="Happy Navratri" />
</div>



{/* Navratri image top-center */}
<div className="navratriImg">
  <img src="assets/img/logo/weconnectlogo.png" alt="Happy Navratri" />
</div>


<div>
  <img src={gifSrc} alt="Celebration" className="celebrationGif gif  w-100" />
</div>


  {/* Bottom Center Button */}
  <div style={{ zIndex: 200, position: "relative", marginBottom:"70px" }}>
    <button
      className="btn bg-primary btn-lg shadow-sm"
      onClick={handleRibonCutting}
      disabled={loading}
    >
      {loading ? (
        <>
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
          />
          Starting...
        </>
      ) : (
        <>
          <i className="fa-solid fa-scissors me-2"></i>
          Start The Journey

        </>
      )}
    </button>
   
  </div>
</div>

    </div>


  );
};

export default WelcomePage;


// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router";
// // import 'bootstrap/dist/css/bootstrap.min.css';
// import './welcome.css'


// const WelcomePage = () => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);
//   const [gifSrc, setGifSrc] = useState("assets/video/beforecutting.png"); // default

//   useEffect(() => {
//     const hasSeen = localStorage.getItem("welcomeSeen");

//     if(hasSeen === "true") {
//       navigate("/login")
//     }
//   }, [navigate]);

//   const handleRibonCutting = () => {
//     //  console.log("vikas")
//     setLoading(true);

//     localStorage.setItem("welcomeSeen", "true");
//     // Reset gif by changing src with a timestamp
//     setGifSrc(`assets/video/cutting.gif?${new Date().getTime()}`);

//     setTimeout(() => {
//       setLoading(false);
//       navigate("/login");
//     }, 5000);
//   };

//   return (
//     <div className="position-relative vh-100 vw-100 overflow-hidden">

//         <img
//           src="assets/video/bgImage.jpg"
//           alt="Navratri Celebration"
//           className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
//         />


//       {/* <video
//         autoPlay
//         loop
//         muted
//         playsInline
//         className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
//       >
//         <source src="assets/video/navratri.mp4" type="video/mp4" />
//         your Browser does not support the video tag.
//       </video> */}


//       {/* Start Content */}
// <div className="position-relative d-flex flex-column justify-content-between align-items-center h-100 text-white p-4">

//   {/* Logo on top-left */}
//   {/* <div
//     style={{
//       position: "absolute",
//       top: "15px",
//       left: "20px",
//       zIndex: 200,
//     }}
//   >
//     <img
//       src="assets/img/logo/weconnectlogo.png"
//       alt="Logo"
//       style={{ maxHeight: "80px" }}
//     />
//   </div> */}


// {/* Navratri image top-center */}
// <div className="navratriImg">
//   <img src="assets/img/logo/weconnectlogo.png" alt="Happy Navratri" />
// </div>

//   {/* Gif in center */}
//   {/* <div>
//     <img
//       src={gifSrc}
//       alt="Celebration"
//       className="w-100"
//       style={{
//         position: "absolute",
//         top: "-100px",
//         left: "0",
//         zIndex: 50,
//         pointerEvents: "none",
//       }}
//     />
//   </div> */}

// <div>
//   <img src={gifSrc} alt="Celebration" className="celebrationGif gif  w-100" />
// </div>


//   {/* Bottom Center Button */}
//   <div className="mb-4" style={{ zIndex: 200, position: "relative" }}>
//     <button
//       className="btn bg-primary btn-lg shadow-sm"
//       onClick={handleRibonCutting}
//       disabled={loading}
//     >
//       {loading ? (
//         <>
//           <span
//             className="spinner-border spinner-border-sm me-2"
//             role="status"
//           />
//           Starting...
//         </>
//       ) : (
//         <>
//           <i className="fa-solid fa-scissors me-2"></i>
//           Start The Journey

//         </>
//       )}
//     </button>
   
//   </div>
// </div>

//     </div>




//     // <div className="relative vh-100 bg-light" style={{ backgroundImage: 'url("https://img.freepik.com/premium-vector/navratri_846499-550.jpg?w=1060")', backgroundRepeat:"no-repeat", backgroundSize:"contain" }} >
//     //    <h1 className="display-5 fw-bold mb-4 text-primary ">Welcome User</h1>

//     //   <div className="p-5 text-center" >

//     //     {/* <p className="mb-4 text-secondary">
//     //       We are excited to have you here! Click the button below to cut the ribbon and get started.
//     //     </p> */}
//     //     <button className="btn btn-success btn-lg shadow-sm"
//     //     onClick={handleRibonCutting}
//     //     disabled={loading}
//     //     >

//     //       {
//     //         loading ? <>  <span className="spinner-border spinner-border-sm me-2" role="status" /> </> : <> <i className="fa-solid fa-scissors me-2"></i>
//     //       Cut the Ribbon </>
//     //       }

//     //     </button>
//     //   </div>
//     // </div>
//   );
// };

// export default WelcomePage;













      // {/* Start Content  */}
      // <div className="position-relative d-flex flex-column justify-content-between align-items-center h-100 text-white p-4">
      //   {/* Logo on top  */}
      //   <div className="text-center">
      //     <img
      //       src="assets/img/logo/weconnectlogo.png"
      //       alt="Logo"
      //       style={{ maxHeight: "120px" }}
      //     />
      //   </div>

      //   {/* Gif in center */}
      //   <div>
      //     <img
      //       src={gifSrc}
      //       alt="Clebration"
      //       className="w-100"
      //       style={{
      //         position: "absolute",
      //         top: "-150px",
      //         left: "0",
      //         zIndex: 50, 
      //         pointerEvents: "none", 
      //       }}
      //     />
      //   </div>

      //   {/* Bottom Center Button */}
      //   <div className="mb-4">
      //     <button
      //       className="btn btn-success btn-lg shadow-sm"
      //       onClick={handleRibonCutting}
      //       disabled={loading}
      //       style={{ zIndex: "200" }}
      //     >
      //       {loading ? (
      //         <>
      //           <span
      //             className="spinner-border spinner-border-sm me-2"
      //             role="status"
      //           />
      //           Cutting...
      //         </>
      //       ) : (
      //         <>
      //           <i className="fa-solid fa-scissors me-2"></i>
      //           Cut the Ribbon
      //         </>
      //       )}
      //     </button>
      //   </div>
      // </div>